import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_EMAIL_IDENTITY_API_URL,
    prepareHeaders: (headers, { getState }) => {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                let userToken = JSON.parse(user).token;
                headers.set('authorization', `Bearer ${userToken}`);
                headers.set('Content-Type', 'application/json');
            } catch (e) {
                console.error('Error parsing user token:', e);
            }
        }
        return headers;
    },
    credentials: "omit"
});

export const emailIdentityServiceApi = createApi({
    reducerPath: "emailIdentityServiceApi",
    baseQuery: baseQuery,
    tagTypes: ["CustomEmailDomain"],
    endpoints: (builder) => ({
        getIdentityStatus: builder.query({
            query: ({ tenancyId }) => `api/identity/status?tenancyId=${tenancyId}`,
            providesTags: (result, error, { tenancyId }) => [
                { type: "CustomEmailDomain", id: tenancyId }
            ]
        }),
        createIdentity: builder.mutation({
            query: ({ tenancyId, parentDomain, localPart, subdomainPrefix }) => ({
                url: 'api/identity/create',
                method: 'POST',
                body: { tenancyId, parentDomain, localPart, subdomainPrefix }
            }),
            invalidatesTags: (result, error, { tenancyId }) => [
                { type: "CustomEmailDomain", id: tenancyId }
            ]
        }),
        checkVerification: builder.mutation({
            query: ({ tenancyId }) => ({
                url: `api/identity/verify?tenancyId=${tenancyId}`,
                method: 'GET'
            }),
            invalidatesTags: (result, error, { tenancyId }) => [
                { type: "CustomEmailDomain", id: tenancyId }
            ]
        }),
        removeIdentity: builder.mutation({
            query: ({ tenancyId }) => ({
                url: `api/identity/remove?tenancyId=${tenancyId}`,
                method: 'DELETE'
            }),
            invalidatesTags: (result, error, { tenancyId }) => [
                { type: "CustomEmailDomain", id: tenancyId }
            ]
        })
    })
});

export const {
    useGetIdentityStatusQuery,
    useLazyGetIdentityStatusQuery,
    useCreateIdentityMutation,
    useCheckVerificationMutation,
    useRemoveIdentityMutation
} = emailIdentityServiceApi;